import { cx } from "class-variance-authority";

import { LinkButton } from "../LinkButton";

import * as style from "./PresetTaskGroup.css";

interface PresetTask {
    icon: React.ReactNode;
    id: string;
    title: string;
    content?: React.ReactNode;
    itemButtonLabel?: string;
    onItemButtonClick?: () => void;
}
interface PresetTaskGroupProps {
    items: PresetTask[];
}
export function PresetTaskGroup({ items }: PresetTaskGroupProps) {
    return (
        <div className={style.root}>
            {items.map((task, index) => (
                <PresetTaskItem
                    key={task.id}
                    isLast={index === items.length - 1}
                    buttonLabel={task.itemButtonLabel}
                    onButtonClick={task.onItemButtonClick}
                    {...task}
                />
            ))}
        </div>
    );
}

interface PresetTaskItemProps extends PresetTask {
    isLast: boolean;
    onButtonClick?: () => void;
    buttonLabel?: string;
}
export function PresetTaskItem({
    icon,
    title,
    content,
    isLast,
    buttonLabel,
    onButtonClick,
}: PresetTaskItemProps) {
    return (
        <div className={cx(style.item, isLast && style.lastItem)}>
            <div className={style.itemHeader}>
                <div className={style.itemTitleIcon}>
                    {icon}
                    <span className={style.itemTitle}>{title}</span>
                </div>
                {onButtonClick && buttonLabel && (
                    <LinkButton onClick={onButtonClick}>
                        {buttonLabel}
                    </LinkButton>
                )}
            </div>
            {content}
        </div>
    );
}
